import React, { useState } from 'react'
import styled from 'styled-components'
import { Colors } from '../../constants'
import { logAmplitudeEvent } from '../../utils'
import { Settings } from '../icons'
import { SettingsModal } from './SettingsModal'

export function SettingsButton() {
  const [open, setOpen] = useState(false)

  return (
    <>
      <Button
        title="Settings"
        onClick={() => {
          setOpen(true)
          logAmplitudeEvent('Settings: Open Modal')
        }}
      >
        <Settings />
      </Button>
      {open && <SettingsModal onClose={() => setOpen(false)} />}
    </>
  )
}

const Button = styled.button`
  padding: 0 20px;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  width: 100%;
  height: 38px;
  color: #868686;
  background-color: #f8f8f8;
  border: 0;
  border-top: 1px solid #cecece;
  outline: 0;
  cursor: pointer;

  &:before {
    position: absolute;
    top: 0;
    left: 0;
    display: block;
    content: '';
    width: 100%;
    height: 1px;
    background-color: ${Colors.White};
  }

  &:hover {
    color: ${Colors.Hover};
  }
`
